import React from 'react';

const OverviewTab = () => {
  return (
    <div>
      
    </div>
  );
};

OverviewTab.propTypes = {};

export default OverviewTab;
